import { createContext } from 'react';
import { LastKnownCards } from '@shared/data/cards/matching/LastKnownCards';
import { createCtx } from '@shared/util/context';

export interface CardUpdatesActions {
  // Registers one card query's refetch under a caller-stable id, or unregisters it with `null`.
  setRefetch: (id: string, refetch: (() => void) | null) => void;
  // Marks one card query as possibly out of date and offers the customer a refetch of it.
  markStale: (id: string) => void;
  // Forgets that one card query was out of date, once it's fetching new data anyway.
  clearStale: (id: string) => void;
  // Whether one card query was marked out of date and hasn't been refetched since.
  isStale: (id: string) => boolean;
}

// Card queries outside a collection view (the card modal's lists, the view builder) have no toast
// to offer a refetch through, so they get these no-ops.
const noCardUpdates: CardUpdatesActions = {
  setRefetch: () => {},
  markStale: () => {},
  clearStale: () => {},
  isStale: () => false,
};

export const [useCardUpdatesActions, CardUpdatesActionsProvider] =
  createCtx<CardUpdatesActions>(noCardUpdates);

// The last known version of each card, shared by every card query in a collection view. Outside
// one there's nothing to share, and each query keeps its own.
export const LastKnownCardsContext = createContext<LastKnownCards | null>(null);
